var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCursorPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_26_47638)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C7.75736 1.5 6.75 2.50736 6.75 3.75V9.07501C5.03832 9.42247 3.75 10.9358 3.75 12.75V15.0579C3.75 16.1521 4.0919 17.219 4.7279 18.1094L6.96669 21.2437C7.52982 22.0321 8.43904 22.5 9.40789 22.5H15.1943C16.2708 22.5 17.2649 21.9231 17.799 20.9884L19.5583 17.9097C20.0116 17.1164 20.25 16.2186 20.25 15.305V12.75C20.25 10.7396 18.668 9.09867 16.6809 9.00429C16.2688 8.54149 15.6684 8.25 15 8.25C14.599 8.25 14.2225 8.3549 13.8965 8.53875C13.4967 7.91407 12.7967 7.5 12 7.5C11.737 7.5 11.4846 7.54512 11.25 7.62803V3.75C11.25 2.50736 10.2426 1.5 9 1.5Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5C7.75736 1.5 6.75 2.50736 6.75 3.75V9.07501C5.03832 9.42247 3.75 10.9358 3.75 12.75V15.0579C3.75 16.1521 4.0919 17.219 4.7279 18.1094L6.96669 21.2437C7.52982 22.0321 8.43904 22.5 9.40789 22.5H15.1943C16.2708 22.5 17.2649 21.9231 17.799 20.9884L19.5583 17.9097C20.0116 17.1164 20.25 16.2186 20.25 15.305V12.75C20.25 10.7396 18.668 9.09867 16.6809 9.00429C16.2688 8.54149 15.6684 8.25 15 8.25C14.599 8.25 14.2225 8.3549 13.8965 8.53875C13.4967 7.91407 12.7967 7.5 12 7.5C11.737 7.5 11.4846 7.54512 11.25 7.62803V3.75C11.25 2.50736 10.2426 1.5 9 1.5ZM11.25 9.75C11.25 10.1642 10.9142 10.5 10.5 10.5C10.0858 10.5 9.75 10.1642 9.75 9.75V3.75C9.75 3.33579 9.41421 3 9 3C8.58579 3 8.25 3.33579 8.25 3.75V13.5C8.25 13.9142 7.91421 14.25 7.5 14.25C7.08579 14.25 6.75 13.9142 6.75 13.5V10.628C5.87611 10.9369 5.25 11.7703 5.25 12.75V15.0579C5.25 15.8395 5.49421 16.6015 5.9485 17.2376L8.18729 20.3719C8.46886 20.7661 8.92346 21 9.40789 21H15.1943C15.7326 21 16.2296 20.7116 16.4966 20.2442L18.2559 17.1655C18.5797 16.5989 18.75 15.9576 18.75 15.305V12.75C18.75 11.7703 18.1239 10.9369 17.25 10.628V11.25C17.25 11.6642 16.9142 12 16.5 12C16.0858 12 15.75 11.6642 15.75 11.25V10.5C15.75 10.0858 15.4142 9.75 15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5C14.25 10.9142 13.9142 11.25 13.5 11.25C13.0858 11.25 12.75 10.9142 12.75 10.5V9.75C12.75 9.33579 12.4142 9 12 9C11.5858 9 11.25 9.33579 11.25 9.75Z",
    fill: "#12131A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_26_47638",
    x: 0.75,
    y: 0,
    width: 22.5,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.0745098 0 0 0 0 0.101961 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_26_47638"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_26_47638",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorPointer);
export default __webpack_public_path__ + "static/media/cursorPointer.e87f47349b8748683f6e89ee6fe1d622.svg";
export { ForwardRef as ReactComponent };